import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import countries from '~/data/countries';
import TLabel from '~/components/atoms/t-label.vue';

interface Props {
  country: string;
}

interface Emits {
  (e: 'update:country', country: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySelect',
  props: {
    country: null
  },
  emits: ["update:country"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:country', country: string): void;
}), expose: any, slots: any, attrs: any }) {



const popularCountries = computed(() => countries.filter(c => ['au', 'gb', 'us'].includes(c.code)));

const onChange = ($event: Event) => {
  if ($event.target instanceof HTMLSelectElement) {
    emit('update:country', $event.target.value);
  }
};

return { __sfc: true,emit, popularCountries, onChange, countries, TLabel }
}

})